/* GrokBot 2026-10-17: Perfil do vinho v3 — scroll-in liquid fill, pointer tilt parallax, tooltips, touch micro-interactions */
(function(){
  var mq=window.matchMedia?matchMedia('(prefers-reduced-motion: reduce)'):{matches:false};
  var fine=window.matchMedia&&matchMedia('(hover:hover) and (pointer:fine)').matches;
  function init(el){
    if(el.hasAttribute('data-vgwp-i'))return;el.setAttribute('data-vgwp-i','');
    var card=el.querySelector('.vgwp__card'),tip=el.querySelector('.vgwp__tip'),tt=el.querySelector('.vgwp__tipt'),tb=el.querySelector('.vgwp__tipb'),rows=[].slice.call(el.querySelectorAll('.vgwp__row')),on=null;
    function place(r){
      var c=card.getBoundingClientRect(),b=r.getBoundingClientRect(),tw=tip.offsetWidth,th=tip.offsetHeight;
      var x=Math.max(12,Math.min(b.left-c.left+8,c.width-tw-12)),y=b.top-c.top-th-10,below=false;
      if(b.top-th-10<8){y=b.bottom-c.top+8;below=true}
      tip.style.left=x+'px';tip.style.top=y+'px';tip.classList.toggle('is-below',below);
      var kb=r.querySelector('.vgwp__knob').getBoundingClientRect();tip.style.setProperty('--ax',Math.max(14,Math.min(tw-24,kb.left-c.left-x+4))+'px');
    }
    function show(r){
      if(on&&on!==r)on.classList.remove('is-on');on=r;
      if(!r){tip.classList.remove('is-on');tip.setAttribute('aria-hidden','true');return}
      r.classList.add('is-on');tt.textContent=r.getAttribute('data-name');var d=r.querySelector('.vgwp__desc');var s=d?d.textContent.replace(/^[^:]+:\s*/,''):'';tb.textContent=s.charAt(0).toUpperCase()+s.slice(1);
      tip.setAttribute('aria-hidden','false');place(r);tip.classList.add('is-on');
    }
    function pop(r){if(mq.matches)return;r.classList.remove('is-pop');void r.offsetWidth;r.classList.add('is-pop');if(navigator.vibrate&&!fine)try{navigator.vibrate(6)}catch(e){}}
    rows.forEach(function(r){
      if(fine){r.addEventListener('mouseenter',function(){show(r)});r.addEventListener('mouseleave',function(){if(on===r)show(null)});}
      r.addEventListener('pointerdown',function(){r._pd=Date.now()});
      r.addEventListener('focus',function(){if(Date.now()-(r._pd||0)<800)return;show(r)});
      r.addEventListener('blur',function(){if(on===r&&!fine)return;if(on===r)show(null)});
      r.addEventListener('click',function(e){e.stopPropagation();if(!fine&&on===r&&tip.classList.contains('is-on')){show(null);return}show(r);pop(r)});
      r.addEventListener('keydown',function(e){if(e.key==='Escape'){show(null);r.blur()}if(e.key==='Enter'||e.key===' '){e.preventDefault();show(r);pop(r)}});
    });
    document.addEventListener('click',function(e){if(on&&!el.contains(e.target))show(null)});
    window.addEventListener('resize',function(){if(on)place(on)});
    // tilt: migrated to shared assets/vg-tilt.js (GrokBot 2026-10-17)
    if(mq.matches||!('IntersectionObserver' in window))return;
    el.classList.add('vgwp--a');
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){requestAnimationFrame(function(){requestAnimationFrame(function(){el.classList.add('is-in')})});io.disconnect();}})},{threshold:.3});
    io.observe(el);
  }
  function run(){document.querySelectorAll('[data-vgwp]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);
})();
